var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1305 22.6496L24.3568 15.9851C23.6912 15.2171 22.471 15.2205 21.6978 15.9953L16.9499 20.7518C15.5368 22.1666 15.1323 24.2675 15.9498 25.952C20.8336 36.064 28.9888 44.2306 39.0939 49.1285C40.7767 49.946 42.8759 49.5416 44.289 48.1267L49.0813 43.3259C49.8578 42.5493 49.8595 41.3222 49.0847 40.6566L42.3946 34.9137C41.6948 34.313 40.6077 34.3915 39.9063 35.0946L37.5784 37.4259C37.4592 37.5508 37.3023 37.6332 37.1318 37.6603C36.9613 37.6874 36.7866 37.6579 36.6346 37.5761C32.8295 35.3849 29.6731 32.2244 27.4868 28.4164C27.405 28.2641 27.3753 28.0891 27.4025 27.9184C27.4296 27.7476 27.512 27.5904 27.637 27.4709L29.9581 25.1482C30.6612 24.4416 30.738 23.3493 30.1305 22.6479V22.6496Z",
    stroke: "#4540DB",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCall);
export default __webpack_public_path__ + "static/media/Profile_Call.c23c43962da607bb5647ca4fd71c984f.svg";
export { ForwardRef as ReactComponent };